import { FaPlus } from "react-icons/fa";

import SupportCalendar from "./charts/SupportCalendar";
import TicketCategoriesChart from "./charts/TicketCategoriesChart";
import TicketRaiseChart from "./charts/TicketRaiseChart";
import SupportStatCard from "./SupportStatCard";

function SupportDashboard() {
  return (
    <>

      {/* DASHBOARD GRID */}
      <div className="w-full mt-4">
        <div
          className="
            grid grid-cols-1
            lg:grid-cols-12
            gap-4
          "
        >
          {/* CALENDAR */}
          <div className="lg:col-span-3">
            <SupportCalendar />
          </div>

          {/* STATS */}
          <div className="lg:col-span-5">
            <SupportStatCard />
          </div>

          {/* BAR CHART */}
          <div className="lg:col-span-4">
            <TicketRaiseChart />
          </div>

          {/* CATEGORY CHART */}
          <div className="lg:col-span-5">
            <TicketCategoriesChart />
          </div>
        </div>
      </div>
    </>
  );
}

export default SupportDashboard;